import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCap20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCap20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.643 7.099 10 4.413l6.356 2.686L10 9.786zm5.968-4.15a1 1 0 0 1 .778 0l7.641 3.228c.814.344.814 1.498 0 1.843L15.71 9h.04v4.25l-.15.199L15 13l.6.45-.002.002-.003.004-.007.01-.01.013-.012.014-.072.086a4 4 0 0 1-.262.274 6 6 0 0 1-1.024.786c-.92.566-2.304 1.111-4.208 1.111-1.331 0-2.408-.266-3.25-.62v1.848l-2 .022-2-.022v-3.111c0-.784.517-1.454 1.25-1.731V8.878L1.968 8.02c-.814-.345-.814-1.499 0-1.843zM6.695 13.432c.708.411 1.789.818 3.305.818 1.602 0 2.717-.455 3.421-.888a4.6 4.6 0 0 0 .829-.647V9.618l-3.86 1.632a1 1 0 0 1-.78 0L5.5 9.512v2.624c.592.224 1.044.705 1.195 1.296m-1.445.44v-.005a.3.3 0 0 0-.11-.224.57.57 0 0 0-.39-.143.57.57 0 0 0-.391.143.3.3 0 0 0-.11.224v1.627l.5.006.5-.006v-1.621"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCap20);
